import { render, staticRenderFns } from "./BoardHeader.vue?vue&type=template&id=1ff58f1c&scoped=true&"
import script from "./BoardHeader.vue?vue&type=script&lang=js&"
export * from "./BoardHeader.vue?vue&type=script&lang=js&"
import style0 from "./BoardHeader.vue?vue&type=style&index=0&id=1ff58f1c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff58f1c",
  null
  
)

export default component.exports